import site from 'pro/config/site';
import Script from 'next/script';

declare const window: any;

export const VConsole: React.FC = () => {
    return (
        <Script
            id="vconsole-sdk"
            src={`${site.cdnRoot}file-asset/file/6b8faff6eceb68f9d76716788b3c075a.js`}
            onReady={() => {
                if(window.VConsole) {
                    window.vConsole = new window.VConsole()
                }
            }}
            strategy="beforeInteractive"
        />
    );
};
export default VConsole;